import Vue from 'vue';
import Router from 'vue-router';
import rootView from '@/views/Root';
import addBalance from '@/components/add-balance';
import history from '@/components/history';
import steamAddBalance from '@/components/steam-add-balance';
import { getBalance, getProducts } from '../plugins/WalletAPI';
import store from '../store';
import config from '@/config/environment-config';
import { getSteamProducts } from '../plugins/steamPurchaseAPI';
Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: '/wallet/',
	routes: [
		{
			path: '/:locale',
			component: rootView,
			props: true,
			children: [
				{
					path: 'add-balance',
					name: 'add-balance',
					component: addBalance,
					beforeEnter: (to, from, next) => {
						Promise.all([getBalance(), getProducts()])
							.then((response) => {
								store.commit('setBalanceData', response[0].data);
								store.commit('setProductsData', response[1].data);
								if (response[1].data.account) store.commit('setAccountData', response[1].data.account);
								next();
							})
							.catch((error) => {
								if (error.response && error.response.data && error.response.data.code) {
									if (error.response.data.code === '001-403-001') {
										window.location.replace(`${window.location.origin}/main/error?error=forbidden`);
									} else if (error.response.data.code !== '001-401-0001') {
										const checkoutWebBaseURL = config[process.env.NODE_ENV][environment.region].checkout;
										window.location = `${checkoutWebBaseURL}/en/failed?error_code=${error.response.data.code}`;
									}
								}
							});
					},
				},
				{
					path: 'history',
					name: 'purchase-history',
					component: history,
					beforeEnter: (to, from, next) => {
						getBalance().then((response) => {
							store.commit('setBalanceData', response.data);
							next();
						});
					},
				},
				{
					path: 'steam-add-balance',
					name: 'steam-add-balance',
					component: steamAddBalance,
					beforeEnter: (to, from, next) => {
						const commerceId = document.getElementById('commerce');
						if (commerceId) commerceId.className = `${to.name} ${to.query.gamecode}`;

						getSteamProducts({ gamecode: to.query.gamecode, session: to.query.session }).then((response) => {
							store.commit('setProductsData', response.data);
							next();
						});
					},
				},
				{
					path: '',
					redirect: 'add-balance',
				},
				{
					path: '*',
					redirect: 'add-balance',
				},
			],
		},
	],
});

router.beforeEach((to, from, next) => {
	const appType = to.query.app_type,
		prodId = to.query.product_id;

	if (appType) {
		store.commit('setAppType', appType);
	}
	if (prodId) {
		Vue.cookie.set('CommerceProdId', prodId);
		store.commit('setProductId', prodId);
	}

	document.body.className = store.state.appType.toLowerCase();

	next();
});

export default router;
